import { useReactiveVar } from '@apollo/client';

import {
  AuthenticationState,
  Path,
  RedirectState,
  getPath,
  sanitizeSameOriginPath,
  useCurrentUser,
  useUrlQueryParam,
} from '@neo.tax/shared';

export const useProfileRedirect = (): RedirectState => {
  const { authenticationServiceState } = useReactiveVar(AuthenticationState.authenticationStateVar);
  const { loading, user } = useCurrentUser();
  const continueUrl = useUrlQueryParam('continueUrl');
  const safeContinueUrl = sanitizeSameOriginPath(continueUrl);

  if (loading || authenticationServiceState.loading) return { isLoading: true };
  if (!authenticationServiceState.authenticationUser)
    return {
      isLoading: false,
      redirectTo: getPath({ path: Path.LOGIN }),
    };
  if (user) {
    if ((!user.organization && user.companies.length === 0) || user.userAttributes.isSsoOnboarding) {
      return {
        isLoading: false,
      };
    }
    // User has completed onboarding. If we arrived with a ?continueUrl= (e.g. forwarded
    // from the accept-invitation flow when useAuthRedirect bounced a user with stale
    // cache here), honor it so they don't get stranded on /profile while their state
    // catches up. Uses the same param name as the email-verification flow for consistency.
    return {
      isLoading: false,
      redirectTo: safeContinueUrl ?? getPath({ path: Path.COMPANIES }),
    };
  }

  return {
    isLoading: false,
  };
};
